<template>
  
    <div>

        <div v-if="init">
            <div class="pt-10 pl-16">
                <h1 class="text-2xl font-bold">Dovolenka</h1>

                <table>
                    <colgroup>
                        <col width="260px">
                        <col width="120px">
                        <col width="70px">
                        <col width="70px">
                        <col width="50px">
                        <col width="210px">
                    </colgroup>
                    <tbody>
                        <tr>
                            <td colspan="3" class="bg-gray-400">
                                <div class="text-sm text-gray-700">Příjmení, jméno, titul</div>
                                <div v-if="user" class="mt-2 text-lg">
                                    {{ user.name }}
                                </div>
                            </td>
                            <td colspan="2" class="bg-gray-400">
                                <div class="text-sm text-gray-700">Osobní číslo</div>
                                <div>
                                    <div v-if="user" class="mt-2 text-lg">
                                        {{ user.number }}
                                    </div>
                                </div>
                            </td>
                            <td class="bg-gray-400">
                                <div class="text-sm text-gray-700">Útvar</div>
                                <div>
                                    <div class="mt-2 text-lg">
                                        &nbsp;
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="6" class="bg-gray-400">
                                <div class="font-bold text-lg mb-4">Čerpání dovolené</div>
                                <div>za kalendářní rok <strong>{{ year }}</strong>, a to od <strong>{{ from }}</strong> do <strong>{{ to }}</strong> včetně, tj. <strong>{{ vacation.hours }}</strong> hodin z prac. doby</div>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="6" class="text-sm">
                                Zaměstnanec se zaměstnavatelem se <strong>dohodli - <s>nedohodli</s></strong>, že z technických důvodů výplata mzdy nebo
                                platu splatná během dovolené nebude vyplacena před nástupem dovolené, ale poukázána v nejbližším
                                pravidelném termínu výplaty mzdy nebo platu na účet zaměstnance nebo poukázána na jeho adresu.
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                <div class="text-sm text-gray-700">Datum</div>
                                <div>
                                    <div class="mt-2 text-lg">
                                        {{ formatDate(vacation.requestedDate) }}
                                    </div>
                                </div>
                            </td>
                            <td colspan="4">
                                <div class="text-sm text-gray-700">Podpis zaměstnance</div>
                                <div>
                                    <div class="mt-2 text-lg">
                                        <i v-if="user">{{ user.name }}</i>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                <div class="text-sm text-gray-700">Datum</div>
                                <div>
                                    <div class="mt-2 text-lg">
                                        {{ formatDate(vacation.approvedDate) }}
                                    </div>
                                </div>
                            </td>
                            <td colspan="4">
                                <div class="text-sm text-gray-700">Podpis zaměstnavatele</div>
                                <div>
                                    <div class="mt-2 text-lg">
                                        <i v-if="approvalUser">{{ approvalUser.name }}</i>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td class="bg-gray-400 align-top">
                                <div class="text-sm text-gray-700">Skutečný nástup dovolené</div>
                                <div>
                                    <div class="mt-2 text-lg">
                                        &nbsp;
                                    </div>
                                </div>
                            </td>
                            <td colspan="3" class="bg-gray-400">
                                <div class="text-sm text-gray-700">Z této dovolené skutečně čerpáno hodin z pracovní doby</div>
                                <div>
                                    <div class="mt-2">
                                        &nbsp;
                                    </div>
                                </div>
                            </td>
                            <td colspan="2" class="bg-gray-400 align-top">
                                <div class="text-sm text-gray-700">Nástup do zaměstnání po dovolené</div>
                                <div>
                                    <div class="mt-2">
                                        &nbsp;
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                <div class="text-sm text-gray-700">Podpis vedoucího</div>
                                <div>
                                    <div class="mt-2">
                                        &nbsp;
                                    </div>
                                </div>
                            </td>
                            <td colspan="4">
                                <div class="text-sm text-gray-700">Za personální utvar</div>
                                <div>
                                    <div class="mt-2">
                                        &nbsp;
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </div>

        <div v-else class="loader loader-dark loader-big ml-4 mt-4 mr-0 mb-0"></div>

    </div>

</template>

<script>
import { db, auth } from '@/firebase';
import moment from 'moment';

export default {

    data() {
        return {
            vacation: null,
            key: this.$route.params.id,
            user: null,
            approvalUser: null
        }
    },
    computed: {

        init() {
            if (this.vacation && this.user) return true
            return false
        },

        year() {
            if (this.vacation) {
                return moment(this.vacation.from.seconds * 1000).year();
            }
        },

        from() {
            if (this.vacation) {
                return moment(this.vacation.from.seconds * 1000).format('DD.MM');
            }
        },

        to() {
            if (this.vacation) {
                return moment(this.vacation.to.seconds * 1000).format('DD.MM');
            }
        }

    },

    methods: {

        getUser() {
            db
            .collection('users')
            .doc(this.vacation.user)
            .get()
            .then(doc => {
                this.user = doc.data()
            })

        },

        formatDate(date) {
            if (date) {
                return moment(date.seconds * 1000).format('DD.MM.YYYY');
            }
        },

        getApprovalUser() {

            if (this.vacation.approvedBy) {
                db
                .collection('users')
                .doc(this.vacation.approvedBy)
                .get()
                .then(doc => {
                    this.approvalUser = doc.data()
                })
            }

        },

        getVacation() {
            db
            .collection('vacations')
            .doc(this.key)
            .get()
            .then(doc => {
                
                this.vacation = doc.data();

                this.getUser()
                this.getApprovalUser()
            })
        }
    },

    created() {
        this.getVacation()
    }    

}
</script>

<style lang="scss" scoped>
    * { 
        font-family: 'Arial', 'Helvetica', sans-serif;
    } 
    table {
        td {
            border: 1px solid black;
            padding: 0.3rem;
            vertical-align: top;
        }
    }
</style>